import { CarQuotation } from './components';

export const StepThree = () => <CarQuotation />;
